import React, { useEffect, useState } from 'react'
import { Row, Col, Button } from 'antd'
import { translate } from 'react-i18next'
import decode from 'jwt-decode';
import { useDispatch } from 'react-redux'
import { BYPASS_TOKEN } from '../../redux/actions/type'
import { routersHelper, login } from '../../helpers'
import { isEmpty } from 'lodash';

const RejoinView = ({ t, keycloak, language, hash }) => {
    const dispatch = useDispatch()
    const { useRouter } = routersHelper
    const router = useRouter()
    const { query: { room, pause } } = router
    const [email, setEmail] = useState('')
    const [name, setName] = useState('')
    const [tempType, setTempType] = useState('')

    useEffect(() => {
        const vtoken = localStorage.getItem('vtoken')
        if (!isEmpty(vtoken)) {
            const { context: { user: { email, name, temp_token, temp_type } } } = decode(vtoken)
            setName(name)
            setEmail(email)
            setTempType(temp_type)

            if (keycloak.authenticated || (!isEmpty(temp_type) && temp_type === "guest")) {
                document.body.style.setProperty("background-color", "#1b2738", "important")
            } else {
                document.body.style.setProperty("background-color", "#fff", "important")
            }

            if ((!isEmpty(temp_token) && temp_token === "Y") && (!isEmpty(temp_type) && temp_type === "guest")) {
                localStorage.removeItem("vtoken")
                window.location.href = `${window._env_.vRoomUrl}/${room}${hash}`
            } else {
                dispatch({
                    type: BYPASS_TOKEN,
                    payload: {
                        room,
                        pause,
                        hash
                    }
                })
            }

        } else {
            window.location.href = '/portal'
        }

    }, [dispatch, room, pause, keycloak.authenticated,hash])

    useEffect(() => {
        //if keycloak services down
        let handleKeycloakdown = setTimeout(() => {
            if (typeof keycloak.createLoginUrl !== "function") {
                if (pause) {
                    console.log('keycloak down', `${window._env_.vRoomUrl}/${room}?isTokenFail=true${hash}`)
                } else {
                    console.log('keycloak down', keycloak)
                    document.body.style.setProperty("background-color", "#1b2738", "important")
                    window.location.href = `${window._env_.vRoomUrl}/${room}?isTokenFail=true${hash}`
                }
            }
        }, 1000);

        return () => {
            clearTimeout(handleKeycloakdown)
        }

    }, [keycloak, room, pause,hash])

    const accessAsGuest = () => {
        localStorage.removeItem("vtoken")
        window.location.href = `${window._env_.vRoomUrl}/${room}${hash}`
    }
    const continueLogin = () => {
        const lang = language === 'cn' ? 'zh-cn' : language
        const loginAsyourself = tempType === 'member' ? '&yourself=true' : ''
        window.location.href = keycloak.createLoginUrl() + `&name=${encodeURIComponent(name.split(" ")[0])}&email=${encodeURIComponent(email)}&ui_locales=${lang}` + loginAsyourself
    }

    return (
        (!isEmpty(keycloak) && !keycloak.authenticated) && (name !== '' && email !== '') ? (
            <>
                <Row className="container">
                    <Col span={24}>
                        <div className="sec1">
                            <Row type="flex" justify="center">
                                <Col lg={2} xs={5}>
                                    {/* eslint-disable-next-line */}
                                    <img src={process.env.PUBLIC_URL + '/img/logo_footer_tvw.png'} style={{ width: '100%' }} />
                                </Col>
                            </Row>
                            <Row type="flex" justify="center" style={{ position: 'relative', top: 70 }}>
                                <Col lg={8} sm={12} xs={22} className="box-content">
                                    <h1>{t("verifyMember_box_header")}</h1>
                                    <div className="box-btn">
                                        <Button className="btn-continue-user" onClick={continueLogin}>{tempType === 'member' ? t("verifyMember_btn_3") : t("verifyMember_btn_1", { name: name.split(" ")[0] })} </Button>
                                    </div>
                                    <div className="box-btn">
                                        <Button className="btn-continue-guest" onClick={accessAsGuest}>{t("verifyMember_btn_2")} </Button>
                                    </div>
                                    {/* eslint-disable-next-line */}
                                    <span>{t('verifyMember_text_1')}&nbsp;<a onClick={login.bind(this, keycloak, language)}>{t('verifyMember_text_2')}</a></span>
                                </Col>
                            </Row>
                        </div>
                    </Col>
                </Row>
            </>
        ) : null
    )
}

export default translate()(RejoinView)
